enum RegistrationNumberVisibilityTypeIds {
  noRegistrationNumber = '9bcb8cfe-e537-4458-9426-1634d6a7d3fb',
  registrationNumberOptional = '8d662ad6-55f1-4a9a-b8d2-0202ce24cd84',
  registrationNumberRequired = '0dba22da-01c5-4333-a8e7-0106a0be66b5',
}

export { RegistrationNumberVisibilityTypeIds }
